
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AsahiInput',
  props: {
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      type: [String, Number],
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    invalid: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    roundedPill: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    },
    placeholderClass: {
      type: String,
      default: ''
    },
    inputBold: {
      type: Boolean,
      default: false
    },
    subTitle: {
      type: String,
      default: ''
    },
    disableShipToAddress: {
      type: Boolean,
      default: false
    },

    isCreateTicket: {
      type: Boolean,
      default: false
    }
  },
  emits: ['input'],
  methods: {
    onInput (event: Event) {
      const input = event.target as HTMLInputElement
      this.$emit('input', input.value)
    }
  }
})
